import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

interface EyebrowProps {
  children: ReactNode;
  /** signal (default) usa cor de acento + tick signal; muted é cinza neutro */
  tone?: 'signal' | 'muted';
  className?: string;
}

/**
 * Eyebrow — kicker mono uppercase com tick à esquerda.
 * Spec: Aura DS v3 §5 (kicker mono 11px tracking 0.16em + régua signal 36×1px).
 *
 * Substitui o padrão inline `<p className="...uppercase tracking-wider text-muted">`.
 *
 * @example
 *   <Eyebrow>Painel</Eyebrow>
 *   <Eyebrow tone="muted">Section</Eyebrow>
 */
export function Eyebrow({ children, tone = 'signal', className }: EyebrowProps) {
  const isSignal = tone === 'signal';
  return (
    <p
      className={cn(
        'flex items-center gap-2 font-mono uppercase',
        'text-[0.6875rem] leading-none tracking-[0.16em]',
        isSignal ? 'text-signal' : 'text-muted',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn('inline-block h-px w-9', isSignal ? 'bg-signal' : 'bg-muted')}
      />
      <span>{children}</span>
    </p>
  );
}
